import React from 'react';
import { levelTone, trimNumber } from './lib/activityFormat';

/** One labelled bar with its number beside it. */
const ScoreBar = ({ label, value, outOf, display }) => (
  <div className="td-act-trait">
    <span>{label}</span>
    <span className="td-act-bar" aria-hidden="true">
      {value != null ? (
        <i className={levelTone(value, outOf)} style={{ width: `${Math.max(0, Math.min(1, value / outOf)) * 100}%` }} />
      ) : null}
    </span>
    <span className="td-act-num">{display ?? (value == null ? '—' : trimNumber(value))}</span>
  </div>
);

export default ScoreBar;
